module.exports = __webpack_public_path__ + "img/asd.f4d82061.png";